import * as React from 'react'
import { Box, Container, Heading, Text } from '@chakra-ui/react'
import PageLayout from '@marco/frontend/layout/PageLayout'
import { GetStaticPropsContext, NextPage } from 'next'
import { getInfo } from '@marco/frontend/sanity/info'
import { HomeProps } from '@marco/frontend/pages/index'

// TODO mutualize with index
export const getStaticProps = async ({ locale }: GetStaticPropsContext) => {
  const info = await getInfo(locale)

  return {
    props: { info },
  }
}
const LegalPage: NextPage<HomeProps> = (props) => (
  <PageLayout htmlTitle={`Marco Lallemant - ${props.info.legal}`} {...props}>
    <Container>
      <Box>
        <Heading mt={16} size="lg">
          Mentions légales
        </Heading>
        <Heading mt={8} size="md">
          Informations juridiques
        </Heading>
        <Text mt={4}>
          HMLB <br />
          33 rue de la République <br />
          69002 Lyon <br />
          SAS au capital social de 10&nbsp;000€ <br />
          Immatriculation au registre du commerce&nbsp;: 810&nbsp;370&nbsp;312
          <br />
          Directeur de la publication&nbsp;: Hugues Maignol
        </Text>
        <Heading mt={8} size="md">
          Politique de confidentialité
        </Heading>
        <Text mt={4}>
          Nous ne collectons aucune de vos données, et c&apos;est la meilleure
          façon de les protéger.
        </Text>
      </Box>
    </Container>
  </PageLayout>
)

export default LegalPage
